import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { generateConfig } from './config'

const config = generateConfig()

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    bugsnag: typeof Bugsnag
  }
}

Bugsnag.start({
  apiKey: config.bugsnagApiKey,
  appVersion: config.appVersion,
  autoTrackSessions: true,
  maxBreadcrumbs: 40,
  enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user'],
  plugins: [new BugsnagPluginReact()],
  releaseStage: config.environment,
})

// Set Bugsnag as global for editor
window.bugsnag = Bugsnag
